export default __webpack_public_path__ + "static/songbaobao-cff6eac983894542aa64ffc0a2adac47.jpg";